import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { getNoticeTemplateList, getNoticeTemplateDetail, changeNoticeTemplateStatus, storeNoticeTemplate, editNoticeTemplate, deleteNoticeTemplate } from './request';
import { cryptoDecrypt } from '@/utils/aes';
import { uploadFile } from './../../customer/applicationManage/request';
export default {
  name: 'noticeTemplateManage',
  data() {
    return {
      action: uploadFile,
      fileList: [],
      noticeTemplates: [],
      noticeTemplateForm: {
        name: '',
        content: '',
        type: '',
        status: 1
      },
      columns: [{
        title: '模板名称',
        dataIndex: 'name',
        key: 'name',
        align: 'center'
      }, {
        title: '模板文件地址',
        dataIndex: 'templateUrl',
        key: 'templateUrl',
        align: 'center'
      }, {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        title: '备注',
        dataIndex: 'remark',
        key: 'remark',
        align: 'center'
      }, {
        title: '操作',
        key: 'operation',
        align: 'center',
        width: 300,
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      noticeTemplateFormRules: {
        name: [{
          required: true,
          message: '请输入模板名称',
          trigger: 'blur'
        }],
        content: [{
          required: true,
          type: 'array',
          validator: this.validateContent,
          trigger: 'change'
        }]
      },
      tableData: [],
      addVisible: false,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      loading: false,
      form: {
        name: ''
      }
    };
  },
  created() {
    this.getNoticeTemplates();
  },
  methods: {
    // 预览处理
    async handlePreview(file) {
      // this.isShow = '';
      // if (!file.url && !file.preview) {
      //   file.preview = await getBase64(file.originFileObj);
      // }
      window.open(file.url || file.response.data.fileTempUrl);
    },
    handleStatusChange(record) {
      console.log(record.status, 'record');
      let changeStatus = record.status ? 'on' : 'off';
      let params = {
        templateId: record.id,
        status: changeStatus
      };
      changeNoticeTemplateStatus(params).then(res => {
        this.$message.success('修改成功');
        this.getNoticeTemplates();
      });
    },
    validateContent(rule, value, callback) {
      if (this.fileList.length === 0) {
        callback(new Error('请上传模板文件'));
      } else {
        callback();
      }
    },
    beforeUpload(file) {
      //判断大小
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.warning(this.$t('上传文件大小不能超过50M'));
      }
      return isLt50M;
    },
    reset() {
      this.form = {
        name: ''
      };
      this.getNoticeTemplates();
    },
    onSearch() {
      this.getNoticeTemplates();
    },
    getNoticeTemplates() {
      let params = {
        name: this.form.name,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      getNoticeTemplateList(params).then(response => {
        this.tableData = response && response.items.map(item => {
          item.status = item.status === 'on' ? true : false;
          return item;
        });
        this.pagination.total = response && response.items ? response.totalCount : 0;
      });
    },
    openAddModal(flag, row) {
      this.noticeTemplateForm = {
        id: '',
        name: '',
        content: '',
        type: '',
        status: 1
      };
      this.fileList = []; // Reset fileList

      if (flag) {
        this.noticeTemplateForm = {
          id: row.id,
          name: row.name,
          content: row.content,
          type: row.type,
          status: row.status,
          remark: row.remark
        };
        // Add existing file to fileList for preview
        if (row.templateUrl) {
          this.fileList = [{
            uid: '-1',
            name: row.name,
            status: 'done',
            url: row.templateUrl
          }];
        }
      }
      this.addVisible = true;
    },
    closeAddVisible() {
      this.$refs.noticeTemplateForm.resetFields();
      this.addVisible = false;
    },
    handleConfirm() {
      this.$refs.noticeTemplateForm.validate(valid => {
        if (valid) {
          let params = {
            name: this.noticeTemplateForm.name || '',
            templateUrl: this.fileList.length > 0 ? this.fileList[0].url : '',
            remark: this.noticeTemplateForm.remark || ''
          };
          console.log(params, 'params');
          this.loading = true;
          if (this.noticeTemplateForm.id) {
            params.templateId = this.noticeTemplateForm.id;
            editNoticeTemplate(params).then(response => {
              this.$message.success('修改成功');
              this.closeAddVisible();
              this.getNoticeTemplates();
            }).finally(() => {
              this.loading = false;
            });
          } else {
            storeNoticeTemplate(params).then(response => {
              this.$message.success('新增成功');
              this.closeAddVisible();
              this.getNoticeTemplates();
            }).finally(() => {
              this.loading = false;
            });
          }
        } else {
          return false;
        }
      });
    },
    handleCancel() {
      this.closeAddVisible();
    },
    handleChange(info) {
      //上传不成功不展示上传的名称
      if (!info.file.status) {
        return;
      }
      if (info.file.status === 'done') {
        console.log(info.file.status, 'info.file.status');
        if (info.file.response.code != 200) {
          this.$message.error(info.file.response.message);
          this.fileList[this.fileList.length - 1].status = 'error';
        }
      }
      let fileList = info.fileList;
      this.fileList = fileList.map(file => {
        if (file.response) {
          // file.url = cryptoDecrypt(file.response.data).fileTempUrl;
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        }
        return file;
      });
    },
    handleStandardTableChange(pagination) {
      this.pagination = pagination;
      this.getNoticeTemplates();
    },
    openDeleteModal(row) {
      const that = this;
      this.$confirm({
        title: '删除模板',
        content: '确认删除该模板吗？',
        onOk: () => {
          let params = {
            templateId: row.id
          };
          deleteNoticeTemplate(params).then(response => {
            that.$message.success('删除成功');
            that.getNoticeTemplates();
          });
        },
        onCancel() {}
      });
    }
  }
};